import { IconProps } from "../../utils/global-types/global-types";

const SortDescendingIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M12 13.5H3c-.45 0-.75-.3-.75-.75S2.55 12 3 12h9c.45 0 .75.3.75.75s-.3.75-.75.75M9.75 9.75H3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h6.75c.45 0 .75.3.75.75s-.3.75-.75.75M7.5 6H3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h4.5c.45 0 .75.3.75.75S7.95 6 7.5 6M13.5 10.5c-.45 0-.75-.3-.75-.75v-6c0-.45.3-.75.75-.75s.75.3.75.75v6c0 .45-.3.75-.75.75"
    ></path>
    <path
      fill="currentColor"
      d="M15.75 6.75a.68.68 0 0 1-.525-.225L13.5 4.8l-1.725 1.725c-.3.3-.75.3-1.05 0s-.3-.75 0-1.05l2.25-2.25c.3-.3.75-.3 1.05 0l2.25 2.25c.3.3.3.75 0 1.05a.68.68 0 0 1-.525.225"
    ></path>
  </svg>
);

export default SortDescendingIcon;
